import PropTypes from "prop-types";
import { formatPrice, getOrdersPrice, getSavePrice } from "../../../helpers";

const PremierPricingTableRow = ({
  orderNum,
  style,
  deliveryData,
  countryData,
  premierDeliveryPrices,
}) => (
  <tr>
    <th className={style.orders} scope="row">
      <span>{orderNum}</span>
    </th>

    <td className={style.gray}>
      <span>
        {formatPrice(getOrdersPrice(orderNum, deliveryData.price.value))}
      </span>
    </td>

    <td className={style.blue}>
      <span>{countryData.price.text}</span>
      <span className={style.save}>
        {getSavePrice(
          orderNum,
          deliveryData.price.value,
          countryData.price.value
        ) > 0
          ? premierDeliveryPrices.saveText.replace(
              "%saveAmount%",
              formatPrice(
                getSavePrice(
                  orderNum,
                  deliveryData.price.value,
                  countryData.price.value
                )
              )
            )
          : null}
      </span>
    </td>
  </tr>
);

PremierPricingTableRow.propTypes = {
  orderNum: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  deliveryData: PropTypes.shape({
    price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }),
  }),
  countryData: PropTypes.shape({
    price: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  }),
  premierDeliveryPrices: PropTypes.shape({
    saveText: PropTypes.string.isRequired,
  }),
};

export default PremierPricingTableRow;
